import React from 'react';
import {
  DateInput,
  DateInputProps,
  StartDateInput,
  StartDateInputProps,
  EndDateInput
} from 'blueprint-form';

import { useScheduleForm } from '../../../contexts/form';

interface StartDateProps extends StartDateInputProps {
  ignoreEditMode?: boolean;
}

export const StartDate: React.FC<StartDateProps> = (props) => {
  const { isEditMode } = useScheduleForm();
  if (isEditMode && !props.ignoreEditMode) {
    return <DateInput {...props} disabled />;
  }
  return <StartDateInput {...props} />;
};

export const EndDate: React.FC<DateInputProps> = (props) => {
  return <EndDateInput {...props} />;
};

export const EditAwareDate: React.FC<DateInputProps> = (props) => {
  const { isEditMode } = useScheduleForm();
  let disabled = false;
  if (isEditMode) {
    disabled = true;
  }
  return <DateInput {...props} disabled={disabled} />;
};
